import React, { useCallback, useEffect, useState } from 'react';
import { Alert, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Snackbar } from '@mui/material';
import { berlangganan } from '../utils/dialog';

// Menampilkan notifikasi & dialog konfirmasi dari utils/dialog.js (pengganti alert/confirm bawaan browser).
// Satu notifikasi tampil sekali waktu (antre), satu konfirmasi sekali waktu.
const BAHAYA = /hapus|delete|batalkan|permanen|tidak dapat dibatalkan/i;

const DialogHost = () => {
  const [notifAktif, setNotifAktif] = useState(null);
  const [antrianNotif, setAntrianNotif] = useState([]);
  const [konfirmAktif, setKonfirmAktif] = useState(null);
  const [antrianKonfirm, setAntrianKonfirm] = useState([]);

  useEffect(() => berlangganan((k) => {
    if (k.jenis === 'notif') setAntrianNotif((a) => [...a, { ...k, id: `${Date.now()}-${Math.random()}` }]);
    else setAntrianKonfirm((a) => [...a, k]);
  }), []);

  // Ambil item berikutnya bila tidak ada yang sedang tampil.
  useEffect(() => {
    if (!notifAktif && antrianNotif.length) { setNotifAktif(antrianNotif[0]); setAntrianNotif((a) => a.slice(1)); }
  }, [notifAktif, antrianNotif]);
  useEffect(() => {
    if (!konfirmAktif && antrianKonfirm.length) { setKonfirmAktif(antrianKonfirm[0]); setAntrianKonfirm((a) => a.slice(1)); }
  }, [konfirmAktif, antrianKonfirm]);

  const tutupKonfirm = useCallback((jawab) => {
    setKonfirmAktif((k) => { if (k) k.resolve(jawab); return null; });
  }, []);

  const bahaya = konfirmAktif ? (konfirmAktif.bahaya ?? BAHAYA.test(konfirmAktif.pesan)) : false;

  return (
    <>
      <Snackbar
        key={notifAktif?.id}
        open={Boolean(notifAktif)}
        autoHideDuration={notifAktif?.severity === 'error' ? 8000 : 5000}
        onClose={(_, alasan) => { if (alasan !== 'clickaway') setNotifAktif(null); }}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        sx={{ zIndex: (t) => t.zIndex.snackbar + 1 }}
      >
        {notifAktif ? (
          <Alert severity={notifAktif.severity} variant="filled" onClose={() => setNotifAktif(null)} sx={{ maxWidth: 560, whiteSpace: 'pre-line' }}>
            {notifAktif.text}
          </Alert>
        ) : undefined}
      </Snackbar>

      <Dialog open={Boolean(konfirmAktif)} onClose={() => tutupKonfirm(false)} maxWidth="xs" fullWidth sx={{ zIndex: (t) => t.zIndex.modal + 10 }}>
        <DialogTitle>{konfirmAktif?.judul || 'Konfirmasi'}</DialogTitle>
        <DialogContent>
          <DialogContentText sx={{ whiteSpace: 'pre-line' }}>{konfirmAktif?.pesan}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => tutupKonfirm(false)}>Batal</Button>
          <Button variant="contained" color={bahaya ? 'error' : 'primary'} onClick={() => tutupKonfirm(true)} autoFocus>
            {konfirmAktif?.tombolYa || (bahaya ? 'Ya, lanjutkan' : 'Ya')}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default DialogHost;
